import React, { Component,useEffect,useState } from "react";
import LastNews from "./lastnews";
import { Link } from 'react-router-dom';

class Policy extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="policy" className="a-breadcrumbs">นโยบายสหกรณ์ออมทรัพย์ไทยออยล์ จำกัด</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>นโยบายสหกรณ์ออมทรัพย์ไทยออยล์ จำกัด</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <a href="FileUpload/Policy/ประกาศความเป็นส่วนตัวของสมาชิก.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>ประกาศความเป็นส่วนตัวของสมาชิก</a>
                <br />
                <br />
                <a href="FileUpload/Policy/นโยบายการคุ้มครองข้อมูลส่วนบุคคล ของ สอ.ไทยออยล์.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>นโยบายการคุ้มครองข้อมูลส่วนบุคคล ของ สอ.ไทยออยล์</a>
                <br />
                <br />
                <a href="FileUpload/Policy/Risk_Management_Policy_of_Thai_Oil_Savings_Cooperative_Announced_on_26_December_2025.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>นโยบายการบริหารจัดการความเสี่ยง ของ สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด</a>
                <br />
                <br />
                {/* <a href="FileUpload/Policy/นโยบายการบริหารจัดการความเสี่ยง ของ สอ.ไทยออยล์.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>นโยบายการบริหารจัดการความเสี่ยง ของ สอ.ไทยออยล์</a>
                <br />
                <br /> */}
                <a href="FileUpload/Policy/Investment_Policy_of_Thai_Oil_Savings_Cooperative_Limited_Announced_on_29_January_2025.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>นโยบายการลงทุน ของ สหกรณ์ออมทรัพย์ไทยออยล์ จำกัด</a>
                <br />
                <br />
                {/* <a href="FileUpload/Policy/นโยบายการลงทุน ของ สอ.ไทยออยล์.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>นโยบายการลงทุน ของ สอ.ไทยออยล์</a>
                <br />
                <br /> */}
                <a href="FileUpload/Policy/นโยบายการกำกับดูแลกิจการ ของ สอ.ไทยออยล์.pdf" target="_blank" className="cws-button" style={{fontSize: 19}}>นโยบายการกำกับดูแลกิจการ ของ สอ.ไทยออยล์</a>
                <br />
                <br />
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
              </div>

              <LastNews />

            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Policy;
